<!--
  NotFoundView.vue — the catch-all `fallback` route ('*').
  Purpose: render a simple 404 for unmatched paths (route name `fallback` in the
  deployed build). Kept intentionally tiny.
  Reconstructed from lacak.io deployed behavior; app-specific contract verbatim
  (route name `fallback` — inventory/routes.md), internal impl re-authored.
-->
<template>
  <v-container fill-height class="tracko-center">
    <div class="text-xs-center">
      <div class="display-3 tracko-muted">404</div>
      <v-btn color="primary" :to="{ name: 'root' }">Back to monitoring</v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'NotFoundView'
}
</script>
